import React from "react";
import { observer } from "mobx-react";
import RegisterVM from "../RegisterVM";
import { ExternalRegistrationStep } from "../../../Models/Registration/Enums/ExternalRegistrationStep";

export interface IKYCDDScriptLoaderComponentProps {
    viewModel: RegisterVM;
}

@observer
export default class KYCDDScriptLoaderComponent extends React.Component<IKYCDDScriptLoaderComponentProps> {
    private containerRef: React.RefObject<HTMLDivElement | null>;
    private scriptRef: HTMLScriptElement | null = null;
    private isUnmounted = false;

    state = {
        redirect: false
    };

    constructor(props: IKYCDDScriptLoaderComponentProps) {
        super(props);
        this.containerRef = React.createRef<HTMLDivElement>();
        this.handleMessage = this.handleMessage.bind(this);
    }

    componentDidMount() {
        if (!this.containerRef.current) return;
    
        const { investor } = this.props.viewModel;
        if (!investor || !investor.externalRegistrationID) return;
    
        window.removeEventListener("message", this.handleMessage);
        window.addEventListener("message", this.handleMessage);
    
        const script = document.createElement("script");
        script.src = "https://iframe.kycdd.co.za/js/load.js";
        script.async = true;
        script.setAttribute("data-workflow_id", investor.workflowID);
        script.setAttribute("data-client_id", investor.externalRegistrationID);
    
        this.scriptRef = script;
        this.containerRef.current.appendChild(script);
    }

    componentWillUnmount() {    
        this.isUnmounted = true;
        window.removeEventListener("message", this.handleMessage);
    
        if (this.scriptRef && this.scriptRef.parentNode) {
            this.scriptRef.parentNode.removeChild(this.scriptRef);
        }
    }
    
    handleMessage = async (event: MessageEvent) => {
        if (event.origin !== "https://iframe.kycdd.co.za") {
            return;
        }
        
        if (
            typeof event.data === "object" &&
            Object.keys(event.data).length === 1 &&
            event.data["1"] === "complete"
        ) {
            if (!this.isUnmounted) {
                await this.props.viewModel.updateExternalRegistrationStep(ExternalRegistrationStep.AwaitingReview);
                window.location.reload();
            }
        }
    };

    render() {
        return <div ref={this.containerRef} className="kycdd-container"></div>;
    }
}
